var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListChecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#list--checked_svg__clip0_61530_7432)",
    fill: "#45464F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 16.5H12V18h10.5v-1.5zM10.5 14.55L9.45 13.5 4.5 18.45 2.55 16.5 1.5 17.55l3 3 6-6zM22.5 6H12v1.5h10.5V6zM10.5 4.05L9.45 3 4.5 7.95 2.55 6 1.5 7.05l3 3 6-6z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "list--checked_svg__clip0_61530_7432"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgListChecked;